import { InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

export const config = environment

export const CONFIG = new InjectionToken<Config>('CONFIG');

export class Config {
  name: string
  production: boolean
  appVersion: any
  analyticsKey: string
  API_HOST: string
  WEBEX_URL: string
  EBSO_URL: string
  apiUrl: string
  logging: Log
  DEPARTMENTS: Departments[]
  AOD_CLIENT_SECRET: string
  EBSO_CLIENT_SECRET: string
  MAINTENANCE_MODE: boolean
  ENABLE_REBOOKING: boolean
  CHAT_PROVIDER: string
  EXTERNAL_API: {}
  UW_CONFIG: {}
}

class Log {
    level: number
    enableSourceMaps: boolean
}

class Departments {
    ID: number
    NAME: string
}

